module.exports = __webpack_public_path__ + "static/media/tab-focused.fecad62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/tab-focused.png
// module id = 406
// module chunks = 0